export default __webpack_public_path__ + "static/media/telegram.1f2b2ca8.svg";